// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2U3wm","backBtn":"styles_backBtn__3oE3u"};